// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import Administrations__BlockedAccountsController from "./administrations/blocked_accounts_controller"
application.register("administrations--blocked-accounts", Administrations__BlockedAccountsController)

import Administrations__RejectPaymentOverridesController from "./administrations/reject_payment_overrides_controller"
application.register("administrations--reject-payment-overrides", Administrations__RejectPaymentOverridesController)

import Administrations__UnblockedAccountsController from "./administrations/unblocked_accounts_controller"
application.register("administrations--unblocked-accounts", Administrations__UnblockedAccountsController)

import AuditTrails__TableController from "./audit_trails/table_controller"
application.register("audit-trails--table", AuditTrails__TableController)

import BankingProfiles__BankingProfilesController from "./banking_profiles/banking_profiles_controller"
application.register("banking-profiles--banking-profiles", BankingProfiles__BankingProfilesController)

import BankingProfiles__CreateBankingProfileController from "./banking_profiles/create_banking_profile_controller"
application.register("banking-profiles--create-banking-profile", BankingProfiles__CreateBankingProfileController)

import Common__PopoverController from "./common/popover_controller"
application.register("common--popover", Common__PopoverController)

import Common__ResizableTablesController from "./common/resizable_tables_controller"
application.register("common--resizable-tables", Common__ResizableTablesController)

import Common__UrlUpdaterController from "./common/url_updater_controller"
application.register("common--url-updater", Common__UrlUpdaterController)

import Forms__ConfirmModalController from "./forms/confirm_modal_controller"
application.register("forms--confirm-modal", Forms__ConfirmModalController)

import Forms__CreateModalController from "./forms/create_modal_controller"
application.register("forms--create-modal", Forms__CreateModalController)

import Forms__DatePicker__DateRangesPopoverController from "./forms/date_picker/date_ranges_popover_controller"
application.register("forms--date-picker--date-ranges-popover", Forms__DatePicker__DateRangesPopoverController)

import Forms__SearchController from "./forms/search_controller"
application.register("forms--search", Forms__SearchController)

import Forms__TextFieldController from "./forms/text_field_controller"
application.register("forms--text-field", Forms__TextFieldController)

import Layout__SidebarController from "./layout/sidebar_controller"
application.register("layout--sidebar", Layout__SidebarController)

import Allocations__DuePaymentsController from "./allocations/due_payments_controller"
application.register("allocations--due-payments", Allocations__DuePaymentsController)

import Allocations__MadeBatchesController from "./allocations/made_batches_controller"
application.register("allocations--made-batches", Allocations__MadeBatchesController)

import Allocations__MadePaymentsController from "./allocations/made_payments_controller"
application.register("allocations--made-payments", Allocations__MadePaymentsController)

import Allocations__ReturnedPaymentsController from "./allocations/returned_payments_controller"
application.register("allocations--returned-payments", Allocations__ReturnedPaymentsController)

import Allocations__ReviewBatchesController from "./allocations/review_batches_controller"
application.register("allocations--review-batches", Allocations__ReviewBatchesController)

import Payments__DuePaymentsController from "./payments/due_payments_controller"
application.register("payments--due-payments", Payments__DuePaymentsController)

import Payments__ManualPaymentController from "./payments/manual_payment_controller"
application.register("payments--manual-payment", Payments__ManualPaymentController)

import Payments__ScheduledPaymentsController from "./payments/scheduled_payments_controller"
application.register("payments--scheduled-payments", Payments__ScheduledPaymentsController)

import Reports__Fa3eReportsController from "./reports/fa3e_reports_controller"
application.register("reports--fa3e-reports", Reports__Fa3eReportsController)

import Reports__FailedAlfaTransactionReportsController from "./reports/failed_alfa_transaction_reports_controller"
application.register("reports--failed-alfa-transaction-reports", Reports__FailedAlfaTransactionReportsController)

import Reports__ScheduledPaymentReportsController from "./reports/scheduled_payment_reports_controller"
application.register("reports--scheduled-payment-reports", Reports__ScheduledPaymentReportsController)

import Sessions__SessionTimeoutController from "./sessions/session_timeout_controller"
application.register("sessions--session-timeout", Sessions__SessionTimeoutController)

import Ui__ButtonController from "./ui/button_controller"
application.register("ui--button", Ui__ButtonController)

import Ui__NotificationsController from "./ui/notifications_controller"
application.register("ui--notifications", Ui__NotificationsController)
